import { Feedback } from "../feedback/Feedback.js";
import { isDictionary } from "../util/dictionary.js";
import { validateDictionary } from "../util/validate.js";
import { Schema } from "./Schema.js";
/** Validate a dictionary object (whose props are all the same with string keys). */
export class DictionarySchema extends Schema {
    items;
    min;
    max;
    constructor({ items, min = 0, max = Infinity, title = "Items", value = {}, ...options }) {
        super({ title, value, ...options });
        this.items = items;
        this.min = min;
        this.max = max;
    }
    validate(unsafeValue = this.value) {
        if (!isDictionary(unsafeValue))
            throw new Feedback("Must be object", unsafeValue);
        const validDictionary = validateDictionary(unsafeValue, this.items);
        const length = Object.keys(validDictionary).length;
        if (length < this.min)
            throw new Feedback(length ? `Minimum ${this.min} items` : "Required", validDictionary);
        if (length > this.max)
            throw new Feedback(`Maximum ${this.max} items`, validDictionary);
        return validDictionary;
    }
}
/** Valid dictionary object with specifed items. */
export const DICTIONARY = (items) => new DictionarySchema({ items });
